import Link from "next/link";
import { Timer } from "lucide-react";
import ImageComponent from "@core/helpers/client/components/image";
import { get_duration_time_server } from "@core/helpers/server/date";
import { user_display_name } from "@core/helpers/user";

// کارت افقی: عکس w-20 (80px)، از md به بعد 116px
const HORIZONTAL_SIZES = "(min-width:768px) 116px, 80px";
// کارت عمودی در گرید صفحه‌ها (دسته، نویسنده، جستجو): تا lg عکس 104px کنار متن است، بعد عرض ستون (۳ ستون، از xl ۴ ستون)
const GRID_SIZES = "(min-width:1280px) 25vw, (min-width:1024px) 33.3vw, 104px";

export default function BlogCard({
    blog,
    storage_prefix_url,
    isHome,
    isCardSlider,
    isBorder,
    variant = "vertical",
    imageClassName,
    contentClassName,
    imageOverlay,
    // عرض واقعی عکس کارت برای انتخاب فایل؛ پیش‌فرض‌ها از کلاس‌های همین کارت اندازه گرفته شده‌اند
    sizes,
}) {

    if (variant === "horizontal") {
        return (
            <Link
                href={blog?.seo?.full_url || "#"}
                className={`group flex flex-row items-center justify-between bg-white rounded-md transition-all duration-200 gap-1 lg:gap-3 h-full w-full overflow-hidden ${isBorder && "border lg:border-0 border-jmt-neutral-200 p-2"}`}>

                <div className={`${imageClassName || "w-20 h-20 md:w-[116px] md:h-[116px]"} rounded-md overflow-hidden shrink-0 bg-jmt-neutral-100 relative`}>
                    {imageOverlay}

                    <ImageComponent
                        src={blog?.media?.url || ""}
                        alt={blog?.media?.alt || blog?.media?.title || blog?.title || ""}
                        style={{ width: "100%", height: "100%" }}
                        width={100}
                        height={100}
                        storage_prefix_url={storage_prefix_url}
                        // w-20 / md:w-[116px]؛ با imageClassName دیگر، صفحه خودش sizes می‌دهد
                        sizes={sizes || (imageClassName ? undefined : HORIZONTAL_SIZES)}
                        image_className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                </div>

                <div className={`flex flex-col justify-between flex-1 h-full min-w-0 ${contentClassName || ""}`}>
                    <div className="flex items-center justify-between gap-1 lg:gap-2">
                        {blog?.category?.title ? (
                            <span className="bg-jmt-neutral-100 text-jmt-neutral-600 text-xs whitespace-nowrap font-bold rounded-xl px-1 py-0.5">
                                {blog?.category?.title}
                            </span>
                        ) : <div />}

                        {blog?.reading_time && (
                            <div className="flex items-center gap-1 text-jmt-neutral-600 whitespace-nowrap">
                                <span className="text-xs lg:text-[13px]">
                                    {blog?.reading_time} دقیقه مطالعه
                                </span>
                                <Timer size={16} />
                            </div>
                        )}
                    </div>

                    <div className="text-[13px] lg:text-sm text-jmt-main font-bold line-clamp-2 lg:h-11 lg:leading-6">
                        {blog?.title}
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="text-xs lg:text-[13px] text-jmt-neutral-600 transition">
                            {user_display_name(blog?.user, { keys: ["full_name", "email"] })}
                        </div>
                        <time
                            dateTime={blog?.publishAt}
                            className="text-xs lg:text-[13px] text-jmt-neutral-600"
                        >
                            {get_duration_time_server(blog?.publishAt)}
                        </time>
                    </div>
                </div>
            </Link>
        );
    }
    return (
        <Link
            href={blog?.seo?.full_url || "#"}
            className={`flex overflow-hidden ${isBorder && "not-last:border-b border-jmt-neutral-200 pb-2 lg:pb-0 lg:border-none"} ${isCardSlider ? "flex-col" : "flex-row lg:flex-col"} ${isHome ? "h-40 lg:h-60 border border-jmt-neutral-200 rounded-md" : "h-full"}`}
        >
            <div className={`${imageClassName || (isCardSlider && isHome ? "w-full h-[120px] lg:h-[174px] rounded-t-md" : isCardSlider ? "w-full h-[150px] lg:h-[174px] rounded-md" : "w-[104px] h-[104px] lg:w-full lg:h-[174px] rounded-md ")} overflow-hidden shrink-0 relative`}>
                {imageOverlay}

                <ImageComponent
                    src={blog?.media?.url || ""}
                    alt={blog?.media?.alt || blog?.media?.title}
                    style={{ width: "100%", height: "100%" }}
                    width={100}
                    height={100}
                    storage_prefix_url={storage_prefix_url}
                    // در اسلایدر، عرض اسلاید از خود اسلایدر می‌آید (ImageSizesProvider)
                    sizes={sizes || (isCardSlider || imageClassName ? undefined : GRID_SIZES)}
                    image_className="w-full h-full object-cover"
                />
            </div>

            {isHome ? (
                <div className={`my-2 px-1 lg:px-2 text-jmt-main ${isCardSlider ? "text-[13px] line-clamp-2" : "text-xs lg:text-[13px] line-clamp-1 lg:line-clamp-2"}`}>
                    {blog?.title}
                </div>
            ) : (
                <div className={`${isCardSlider ? "mr-0 mt-2" : "mr-3 lg:mr-0 mt-0 lg:mt-2"} ${contentClassName || ""} flex-1 space-y-2 min-w-0`}>
                    <div className="flex justify-between">
                        {blog?.category?.title && (
                            <span className="bg-jmt-neutral-100 text-jmt-neutral-600 text-xs whitespace-nowrap font-bold rounded-xl px-1 py-0.5">
                                {blog?.category?.title}
                            </span>
                        )}

                        {blog?.reading_time && (
                            <div className="flex items-center gap-1 text-jmt-neutral-600 whitespace-nowrap">
                                <span className="text-xs lg:text-[13px]">
                                    {blog?.reading_time} دقیقه مطالعه
                                </span>
                                <Timer size={16} />
                            </div>
                        )}
                    </div>
                    <div className="text-[13px] lg:text-sm text-jmt-main font-bold line-clamp-2 h-11 leading-6">
                        {blog?.title}
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="text-xs lg:text-[13px] text-jmt-neutral-600 transition">
                            {user_display_name(blog?.user, { keys: ["full_name", "email"] })}
                        </div>
                        <time
                            dateTime={blog?.publishAt}
                            className="text-xs lg:text-[13px] text-jmt-neutral-600"
                        >
                            {get_duration_time_server(blog?.publishAt)}
                        </time>
                    </div>
                </div>
            )}
        </Link>
    );
}
